import Image from 'next/image';

export const CategoryBanner = ({ categoryData }: { categoryData: any }) => {
  const categoryImage =
    categoryData && categoryData.categories.items.length ? categoryData.categories.items[0].category_image : null;

  const categoryName =
    categoryData && categoryData.categories.items.length ? categoryData.categories.items[0].name : null;

  if (!categoryImage) {
    return null;
  }

  return (
    <Image
      src={categoryImage}
      width={1268}
      height={370}
      loading={'eager'}
      alt={categoryName}
      className='w-full'
    />
  );
};
